import { createAction } from "@redux/actions/actionCreators";

const [useRevertProduct, revertProduct] = createAction<{
  productUuid: string;
}>("product/revert");

export default useRevertProduct;
export { revertProduct };
